import { render, staticRenderFns } from "./BaseDraggable.vue?vue&type=template&id=786a0282&"
import script from "./BaseDraggable.vue?vue&type=script&lang=js&"
export * from "./BaseDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports